import Select from "@visa/vds/select";
import React from "react";
import { useController } from "react-hook-form";
import { FormHelper } from "../_helpers/FormHelper";

function MCSControlSelect(props) {
  const { field, fieldState } = useController(props);
  const handleChange = (e) => {
    if (!props.hasConfirmation) {
      field.onChange(e);
    }
    props.handleChange(e)
  };

  return (
    <Select
      readOnly={props.readOnly}
      {...field}
      onChange={handleChange}
      label={props.label}
      invalid={fieldState.invalid}
      showErrorText={fieldState.invalid}
      errorText={FormHelper.renderErrorMsg(fieldState.error)}
      contentBeforeInput={props.contentBeforeInput}
    >
      {props.options}
    </Select>
  );
}

export default MCSControlSelect;
